import classNames from 'classnames';
import React, { useCallback, useContext } from 'react';
import { Button } from '@fluentui/react-components';
import { ChevronLeftRegular, ChevronRightRegular } from '@fluentui/react-icons';
import { ScopeContext } from '@bingads-webui-react/scope-service';

import { useFooterStyles } from '../styles/footer-styles';
import { IScopeContext, FooterProps } from '../utils/types';

export function Footer({
  showPagination,
  paginationConfig,
  i18n,
  campaignType,
}: FooterProps) {
  const styles = useFooterStyles();
  const { scope } = useContext(ScopeContext) as IScopeContext;
  const {
    current, total, onNext, onPrevious,
  } = paginationConfig;

  const onClick = useCallback(() => {
    let path = '/campaign/vnext/locations/campaign';
    // LinkedIn campaigns don't support campaign locations grid so far, so route user to campaign settings page
    if (campaignType === 'LinkedIn') {
      path = '/campaign/vnext/settings';
    }
    scope.save(path);
  }, [campaignType, scope]);

  return (
    <div className={classNames('footer', styles.footer)}>
      <Button className={classNames('action-button', 'view-all-clickLink')} onClick={onClick}>{i18n.getString(_TL_('View location targets'))}</Button>
      {showPagination &&
        <div className="pagination-container">
          <Button className="previous-button" onClick={onPrevious} disabled={current <= 1} icon={<ChevronLeftRegular />} appearance="transparent" aria-label={i18n.getString('Previous')} />
          <span className="text">{i18n.getString(_TL_('{{current}} of {{total}}'), { current, total })}</span>
          <Button className="next-button" onClick={onNext} disabled={current >= total} icon={<ChevronRightRegular />} appearance="transparent" aria-label={i18n.getString('Next')} />
        </div>
      }
    </div >
  );
}
